<template>
  <li>
    <div class="back"></div>
    <article class="card">
      <div class="card-image">
        <div class="image">
          <!-- <el-image :src="product.productImg" :fit="cover" :lazy="true"/> -->
          <img :src="product.productImg"/>
        </div>
      </div>
      <div class="card-info">
        <span class="price">{{ product.price }}</span>
      </div>
    </article>
    <div class="actions">
      <div>
        <el-button type="warning" plain @click="buy(productIndex)">BUY</el-button>
        <!-- <BaseButton link :to="`/teachers/12/contact`" mode="outline">Buy</BaseButton> -->
      </div>
    </div>
  </li>
</template>

<script>

export default {
  name: 'productItem',
  props: ['product', 'productIndex'],
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    buy (index) {
      this.$parent.productCheck(index)
    }
  }
}

</script>

<!-- 覆盖样式 -->
<style>
</style>

<style scoped>
li {
  position: relative;
  display: flex;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.8) 0px 30px 60px -30px;
  padding: 0px 0px 0px 0px;
  border-radius: 5px;
  margin: 16px;
  width: 280px;
  max-width: 280px;
  -webkit-flex: 1;
  /* Chrome */
  -ms-flex: 1;
  /* IE 10 */
  flex: 1;
  /* NEW, Spec - Opera 12.1, Firefox 20+ */
  -webkit-box-flex: 1;
  /* OLD - iOS 6-, Safari 3.1-6 */
  -moz-box-flex: 1;
  /* OLD - Firefox 19- */
  background-color: rgb(255, 255, 255);
  flex-direction: column;
  align-items: center;
  transition: all .2s ease-out;
}

.card {
  background-color: #bba04b;
  display: inline;
  width: 100%;
  justify-content: space-between;
}

.card .card-image img {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  object-fit: cover;
  object-position: right;
  height: 200px;
  width: 278px;
}

.card-info {
  flex: 1;
  font-family: SourceHanSansCN-Regular;
  font-size: 15px;
  font-weight: 700;
  font-stretch: normal;
  letter-spacing: 0;
  color: #0c0c0c;
}

.card-info .title {
  height: 20px;
}

.card-info .price {
  font-size: 22px;
  font-weight: 700;
  font-stretch: normal;
}

.actions {
  display: flex;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
  opacity: 0;
  transition: all .2s ease-out;
  transition-delay: .2s;
  z-index: 1;
}

.actions div {
  margin-left: 10px;
  margin-bottom: 5px;
}

.back {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.849);
  transition: all 0.2s ease-out;
  z-index: 1;
  transform: scaleX(0);
}

li:hover .back {
  transform: scaleX(1);
  transform-origin: top;
}

li:hover .actions {
  opacity: 1;
}

@media only screen and (max-width: 970px) {
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #444;
  }
}

@media only screen and (max-width: 768px) {}

@media only screen and (max-width: 630px) {
  li {
    min-width:360px;
    height: 172px;
    padding: 0px;
    margin: 5px 0 5px 0;
  }

  .card {
    flex-direction: row;
    display: flex;
    display: -moz-box;
    /* Firefox 17- */
    display: -webkit-flex;
    /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
    display: -moz-flex;
    /* Firefox 18+ */
    display: -ms-flexbox;
    /* IE 10 */
  }

  .card .card-image {
    height: 170px;
    width: 226px;
  }

  .card .card-image img {
    height: 170px;
    width: 226px;
    object-fit: cover;
    object-position: right;
  }

  .card-info {
    margin-left: 5px;
  }

  .card-info .price {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 170px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/shop/components/productItem.vue